import { GameMenuKey } from '../../../../model';
import { getPathnameByGameInfo } from '../../lib';
import './style.scss';
import ServicesMore from '../../../../assets/img/services-more.png';
import React from 'react';
import { Loading } from '../../../../components/loading';
import getFormatMessage from '../../../../locales/get-format-message';

interface IProps {
  readonly goToRouter: (pathname: string) => void;
  readonly icon: string;
  readonly title: string;
  readonly isLoading: boolean;
  readonly children: React.ReactNode;
}

export const RecommendLayout = (props: IProps) => {
  return (
    <div className="recommend-layout">
      <div className="recommend-header">
        <img src={props.icon} className="icon" />
        <div className="title">{props.title}</div>
        <button
          className="more-button"
          onClick={() =>
            props.goToRouter(getPathnameByGameInfo(GameMenuKey.AllProduct))
          }
        >
          {getFormatMessage('more')} <img src={ServicesMore} />
        </button>
      </div>
      <div className="recommend-content">
        <Loading isLoading={props.isLoading} height="96px" />
        {props.children}
      </div>
    </div>
  );
};
